import React, { PureComponent } from 'react'
import { Paper, Button, Grid } from '@material-ui/core'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import LockOpen from '@material-ui/icons/LockOpen'
import { connect } from 'react-redux'

import { openErrorMessage } from '../../actions/message'
import ModalDialog from '../common/ModalDialog'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'

class ResetSettings extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
    }
  }

  openModal = () => {
    this.confirmModal.handleClickOpen()
  }

  setPassword = (event) => {
    this.setState({
      password: event.target.value,
    })
  }

  onConfirm = () => {
    Appcues.track('Reset Shop Settings')
    const { password = '' } = this.state

    if (!password || !password.trim()) {
      return this.props.dispatch(openErrorMessage('Please enter your password'))
    }

    this.props.onConfirm(this.state.password).then((res) => {
      this.confirmModal.handleClose()
    })
  }

  resetPassword = () => {
    this.setState({
      password: '',
    })
  }

  render() {
    const paperStyle = {
      marginBottom: 20,
    }

    const { title = '', info = '', confirmText = '', modalInfo = '', buttonTitle } = this.props
    const { password = '' } = this.state

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page" elevation={2} style={paperStyle}>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={12} md={9} lg={9}>
                  <ListItemText>
                    <h3>{title}</h3>
                  </ListItemText>
                  {info}
                </Grid>
                <Grid className="reset-pro-btn" item xs={12} sm={12} md={3} lg={3}>
                  {hasAccess() ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      className="primary-button pull-right margin-bottom-small"
                      onClick={this.openModal}
                    >
                      {buttonTitle}
                    </Button>
                  ) : null}
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
        </Grid>

        <ModalDialog
          title={title}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirm}
          confirmText={confirmText}
          onClose={this.resetPassword}
        >
          <p>{modalInfo}</p>
          <p>Once performed, you will not be able to re-store the data.</p>
          <FormControl fullWidth>
            <InputLabel htmlFor="input-with-icon-adornment">Please enter your Password</InputLabel>
            <Input
              onChange={this.setPassword}
              value={password}
              type="password"
              id="input-with-icon-adornment"
              startAdornment={
                <InputAdornment position="start">
                  <LockOpen />
                </InputAdornment>
              }
            />
          </FormControl>
        </ModalDialog>
      </Grid>
    )
  }
}
export default connect((state) => ({ dispatch: state.dispatch }))(ResetSettings)



// WEBPACK FOOTER //
// ./src/components/ResetSettings/index.js